module.exports = __webpack_public_path__ + "static/media/ic_map_legend.d3c299dd.svg";